import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=54baa577&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"
import "./TagView.vue?vue&type=style&index=0&id=54baa577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baa577",
  null
  
)

export default component.exports